export const ZERO_COMMISSION =
  "Atlas Advisory accepts no commissions, referral fees, or payments from any government, developer, fund, law firm, or agent.";

export const NOT_ADVICE =
  "Information only. Not legal or tax advice. Verify with primary sources and qualified professionals before acting.";
